<template>
  <div class="user-content-page">
    <div class="container-box">
      <div class="fs-14 breadcrumb">
        <span class="c-9 cup" @click="$navigate('/personal', null, false)">
          {{ breadcrumbName }}
        </span><span class="ml-6 mr-6">/</span>
        <span>{{ pageTitle }}</span>
      </div>
      <div class="discuss-box" v-loading="loading">
        <div class="list-box" v-if="list.length">
          <div class="list" v-for="item in list" :key="itemKey(item)" @click="openDetail(item)">
            <div class="t1s df aic over-h">
              <div class="mic-semblod df aic one-text">
                <span class="essence" v-if="rec(item) == 900">{{ $t('精1') }}</span>
                <span class="hot" v-if="rec(item) == 1000">{{ $t('顶1') }}</span>
                <div class="f1 one-text">{{ title(item) }}</div>
              </div>
            </div>
            <div class="desc tow-text" v-if="desc(item)">{{ desc(item) }}</div>
            <div class="userinfo-box df jcsb aic over-h">
              <div class="users df aic f1 over-h">
                <el-avatar :size="18" :src="item.user_avatar_att_url" class="fn">
                  <img src="@/assets/images/avatar.png" alt="">
                </el-avatar>
                <span class="name fn">{{ displayName(item) }}</span>
                <div class="f1 type one-text" v-if="excelArr(item).length">
                  <span v-for="(tag, index) in excelArr(item)" :key="index">{{ tag.label }}</span>
                </div>
              </div>
              <div class="dates df fn">
                <div class="comment-list df">
                  <div class="li">
                    <span class="iconfont">&#xe611;</span>
                    <span class="text">{{ item.tp_hits || item.ttar_hits || 0 }}</span>
                  </div>
                  <div class="li">
                    <span class="iconfont">&#xe61b;</span>
                    <span class="text">{{ item.tp_likes || item.ttar_likes || 0 }}</span>
                  </div>
                  <div class="li">
                    <span class="iconfont">&#xe63e;</span>
                    <span class="text">{{ item.reply_count || 0 }}</span>
                  </div>
                </div>
                <span class="date">{{ timeText(item) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-else-if="!loading">
          <img src="@/assets/images/empty_data.png" alt="" />
          <p>{{ $t('暂无数据') }}</p>
        </div>
        <div class="pageing-box df aic jcc" v-if="total > pageSize">
          <el-pagination
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            layout="prev, pager, next"
            @current-change="handlePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserPostList, getUserArticleList } from "@api/usercenter";
import { getuserDetail } from "@api/common";

export default {
  name: "UserContentList",
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      userNickName: "",
      userLoaded: false,
    };
  },
  computed: {
    isPost() {
      return this.$route.meta.contentType === "post";
    },
    pageTitle() {
      return this.isPost ? this.$t("帖子") : this.$t("文章");
    },
    userId() {
      return this.$route.params.user_id;
    },
    /**
     * 面包屑昵称，不依赖列表数据
     * @returns {string}
     */
    breadcrumbName() {
      if (this.userNickName) {
        return this.userNickName;
      }
      return this.userLoaded ? this.$t("匿名用户") : "";
    },
  },
  watch: {
    "$route.fullPath"() {
      this.page = 1;
      this.load();
      this.loadUser();
    },
  },
  mounted() {
    this.load();
    this.loadUser();
  },
  methods: {
    /**
     * 根据路由用户 ID 拉取昵称，避免列表为空时面包屑空白
     */
    async loadUser() {
      if (!this.userId) {
        this.userNickName = "";
        this.userLoaded = true;
        return;
      }
      this.userLoaded = false;
      const res = await getuserDetail({ id: this.userId });
      if (res && res.status == 200 && res.data) {
        this.userNickName = res.data.user_nick_name || "";
      } else {
        this.userNickName = "";
      }
      this.userLoaded = true;
    },
    async load() {
      if (!this.userId) return;
      this.loading = true;
      try {
        const api = this.isPost ? getUserPostList : getUserArticleList;
        const res = await api({
          user_id: this.userId,
          page: this.page,
          pagesize: this.pageSize,
        });
        if (res && res.status == 200) {
          const pageData = res.data || {};
          this.list = pageData.data || [];
          this.total = pageData.total || 0;
        } else {
          this.list = [];
          this.total = 0;
        }
      } finally {
        this.loading = false;
      }
    },
    handlePage(page) {
      this.page = page;
      this.load();
    },
    itemKey(item) {
      return this.isPost ? item.tp_id : item.ttar_id;
    },
    title(item) {
      return this.isPost ? item.tp_title : item.ttar_title;
    },
    desc(item) {
      return this.isPost ? item.tp_desc : item.ttar_desc;
    },
    rec(item) {
      return this.isPost ? item.tp_rec : item.ttar_rec;
    },
    excelArr(item) {
      if (this.isPost && Number(item.tp_type) === 20) return [];
      return Array.isArray(item.user_excel_arr) ? item.user_excel_arr : [];
    },
    displayName(item) {
      if (this.isPost && Number(item.tp_type) === 20) {
        return this.$t("匿名用户");
      }
      return item.user_nick_name || this.$t("匿名用户");
    },
    timeText(item) {
      const ts = this.isPost ? item.tp_published_time : item.create_time;
      if (!ts) return "";
      // 判断是否是时间戳
      // if (Number.isNaN(Number(ts))) return "";
      const date = new Date(Number(ts) * 1000);
      if (Number.isNaN(date.getTime())) return ts;
      const p = (n) => (n < 10 ? "0" + n : "" + n);
      return `${date.getFullYear()}.${p(date.getMonth() + 1)}.${p(date.getDate())}`;
    },
    openDetail(item) {
      if (this.isPost) {
        this.$navigate("/discuss/info", item.tp_id);
      } else {
        this.$navigate("/subject/info", item.ttar_id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-pagination {
    display: flex;
    align-items: center;
  }
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: transparent;
  }
}

.user-content-page {
  width: 100%;
  min-height: calc(100vh - 280px);
  padding: 60px 80px 60px;
}

.container-box {
  max-width: 1400px;
  margin: 0 auto;
}

.breadcrumb {
  margin-top: 24px;
}

.discuss-box {
  min-height: 320px;
  .list-box {
    margin-top: 18px;
  }
  .list {
    padding: 16px 0;
    border-bottom: 1px solid rgb(226, 226, 226);
    cursor: pointer;
    transition: border-bottom 0.36s;
    &:hover {
      border-bottom-color: #b7251e;
      .t1s {
        color: #b7251e;
      }
    }
  }
  .t1s {
    color: rgb(25, 25, 25);
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    padding: 2px 0;
    .mic-semblod {
      min-width: 0;
      width: 100%;
    }
  }
  .essence,
  .hot {
    display: inline-block;
    min-width: 18px;
    height: 18px;
    border-radius: 2px;
    font-size: 14px;
    color: #fff;
    line-height: 18px;
    text-align: center;
    margin-right: 4px;
    padding: 0 2px;
    flex: none;
  }
  .essence {
    background: rgb(215, 17, 17);
  }
  .hot {
    background: #fdb906;
  }
  .desc {
    color: rgb(51, 51, 51);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    max-height: 44px;
    margin-top: 10px;
  }
  .userinfo-box {
    height: 32px;
    margin-top: 8px;
  }
  .name {
    font-size: 14px;
    margin-left: 6px;
  }
  .type {
    height: 32px;
    position: relative;
    margin-left: 18px;
    padding: 5px 18px;
    &::after {
      content: "";
      display: block;
      height: 14px;
      width: 1px;
      background-color: #d8d8d8;
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 0;
    }
    span {
      display: inline-block;
      height: 22px;
      background-color: #f0f1f1;
      border-radius: 4px;
      padding: 0 4px;
      color: #868d9f;
      line-height: 22px;
      font-size: 12px;
      margin-right: 6px;
    }
  }
  .dates {
    height: 32px;
    line-height: 32px;
  }
  .date {
    font-size: 14px;
    color: #868d9f;
    position: relative;
    padding-left: 16px;
    &::after {
      content: "";
      display: inline-block;
      height: 12px;
      width: 1px;
      background-color: #d8d8d8;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -6px;
    }
  }
  .comment-list .li {
    color: #868d9f;
    font-size: 14px;
    margin-right: 15px;
    .iconfont {
      margin-right: 5px;
    }
  }
}

.no-data {
  text-align: center;
  padding: 64px 0;
  color: #999;
  img {
    width: 160px;
  }
}

.pageing-box {
  margin-top: 60px;
  padding-bottom: 120px;
}
</style>
